module.exports = __webpack_public_path__ + "images/avatars/female/20.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/20.svg
// module id = +kS6
// module chunks = 154